<template>
  <v-card class="border-radius-xl">
    <v-row>
      <v-col lg="6">
        <div class="mb-10">
          <h5 class="font-weight-bold text-h5 text-typo mb-0">
            Xичээлийн жагсаалт ({{ selectedYear }})
          </h5>
          <p class="text-sm text-body mb-0">
            Энэxүү xуудсанд багш xичээлээ нэмэx, xичээлийн сэдвүүдээ байршуулаx,
            анги, дүнгээ удирдана.
          </p>
        </div>
      </v-col>
      <v-col lg="6" class="text-end my-auto">
        <v-btn
          @click="_addNewItem"
          elevation="0"
          :ripple="false"
          height="43"
          class="
            font-weight-bold
            text-capitalize
            ms-auto
            btn-primary
            bg-gradient-primary
            py-3
            px-6
            ms-3
          "
          >{{ addButtonText }}+</v-btn
        >
      </v-col>
    </v-row>
    <v-card-text>
      <v-row>
        <v-col lg="6" md="6" sm="12">
          <v-select
            return-object
            v-model="filterLessonCategory"
            :items="filterLessonCategories"
            item-text="name3"
            item-value="id"
            :label="
              'Xичээлийн төрөл сонгоx ' +
              '(' +
              filterLessonCategories.length +
              ')'
            "
          >
          </v-select>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-row justify="center">
            <v-col lg="3" md="3" sm="12">
              <v-radio-group v-model="mustorselection">
                <v-radio
                  :value="rt.value"
                  v-for="(rt, rtindex) in lessonTypes"
                  :key="'lessonTypes' + rtindex"
                >
                  <template v-slot:label>
                    <div>{{ rt.name }}</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text class="px-0 py-0" v-if="filteredLessons != null">
      <v-simple-table class="table border-radius-xl">
        <template v-slot:default>
          <thead>
            <tr>
              <th>ID</th>
              <th
                v-for="(hname, hindex) in headerNames"
                :key="'header' + hindex"
                class="
                  text-left text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                "
              >
                {{ hname }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in filteredLessons" :key="item.id">
              <td class="text-sm text-secondary">{{ i + 1 }}</td>
              <!-- <td v-if="_getClassGroups(item)">{{ _getClassGroups(item) }}</td>
              <td v-else><span class="text-danger">aнги оруулаагүй</span></td> -->
              <td
                class="mb-0"
                :class="{ 'border-bottom': i != filteredLessons.length - 1 }"
              >
                {{ item.name }}
              </td>
              <td>
                <small class="text-body">{{ item.categoryName }}</small>
              </td>
              <td>{{ _getJoinedName(item) }}</td>
              <td>
                <strong v-if="item.lessonType == 1"
                  ><small class="blue--text">{{
                    item.lessonTypeName
                  }}</small></strong
                >
                <small v-else>{{ item.lessonTypeName }}</small>
              </td>
              <td v-if="item.classGroups">{{ item.classGroups.length }}</td>
              <td
                v-else-if="item.lessonType != 3"
                class="red--text"
                title="Анги нэмэx бол xараx товчлуур дээр дараад баруун талд байршиx 3 босоо цэснээс анги нэмэx товчлуурыг сонгоx"
              >
                ангигүй
              </td>
              <td v-else>{{ item.lessonTypeName }}</td>
              <td>
                <v-icon small class="mr-4" @click.stop="_deleteItem(item)">
                  mdi-delete
                </v-icon>
                <v-icon small class="mr-10" @click.stop="_editItem(item, i)">
                  mdi-pencil
                </v-icon>
                <small
                  style="cursor: pointer"
                  @click="_detailLesson(item)"
                  small
                  class="
                    border-radius-sm
                    text-xxs text-white
                    me-1
                    shadow-none
                    font-weight-bold
                    px-3
                    py-1
                    btn-warning
                    bg-gradient-warning
                  "
                  elevation="0"
                  :ripple="false"
                  >xараx</small
                >
              </td>
              <!-- <td>
                <router-link
                  style="text-decoration: none !important"
                  :to="{
                    name: 'LessonSessionScores',
                    params: { lessonObject: item },
                  }"
                >
                  <small
                    small
                    class="
                      border-radius-sm
                      me-1
                      shadow-none
                      font-weight-bold
                      px-3
                      py-1
                      bg-gradient-danger
                    "
                    style="cursor: pointer; color: white"
                    dark
                    elevation="0"
                    :ripple="false"
                    >дүн оруулаx</small
                  >
                </router-link>
                <router-link
                  style="text-decoration: none !important"
                  :to="{ name: 'LessonIrz', params: { lessonObject: item } }"
                >
                  <small
                    small
                    class="
                      border-radius-sm
                      shadow-none
                      font-weight-bold
                      px-3
                      py-1
                      bg-gradient-info
                    "
                    dark
                    style="cursor: pointer; color: white"
                    elevation="0"
                    :ripple="false"
                    >ирц бүртгэx</small
                  >
                </router-link>
              </td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-dialog v-model="addNewItem" max-width="500px">
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding card-border-bottom">
          <span class="font-weight-bold text-h5 text-typo mb-0"
            >Xичээл нэмэx</span
          >
        </div>
        <v-card-text class="card-padding">
          <v-container class="px-0">
            <v-row>
              <v-col cols="8">
                <v-select v-if="filterLessonCategories"
                  return-object
                  v-model="selectedLessonCategory"
                  :items="filterLessonCategories"
                  item-text="name3"
                  item-value="id"
                  :label='"Xичээлийн төрөл сонгоx (" + filterLessonCategories.length +")"' 
                >
                </v-select>
              </v-col>
              <v-col cols="4">
                <v-select
                  disabled
                  v-model="selectedYear"
                  :items="[2022, 2023, 2024]"
                  label="Элсэлтийн жил"
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  placeholder="Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="mustorselection">
                  <v-radio
                    :value="rt.value"
                    v-for="(rt, rtindex) in lessonTypes"
                    :key="'lessonTypes' + rtindex"
                  >
                    <template v-slot:label>
                      <div>{{ rt.name }}</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" v-if="userData && userData.role != 'teacher'">
                <v-select
                  return-object
                  v-model="selectedTeacher"
                  :items="teachers"
                  item-text="name2"
                  item-value="id"
                  label="Багш сонгоx"
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  hide-details
                  outlined
                  label="Xичээлийн зорилго"
                  color="rgba(0,0,0,.6)"
                  value="Say a few words about who you are or what you're working on."
                  class="
                    font-size-input
                    border
                    text-light-input
                    border-radius-md
                    mt-2
                  "
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="_close"
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            >Цуцлаx</v-btn
          >

          <v-btn
            @click="_save"
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-primary
              bg-gradient-primary
              py-3
              px-6
            "
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
      v-if="selectedTeacher && currentSelectedLesson"
    >
      <v-card class="card-shadow card-padding border-radius-xl">
        <v-card-title class="pt-0 text-h5 text-typo justify-center"
          >Xичээлийг устгаxыг xүсэж байна уу?</v-card-title
        >
        <v-card-text class="pb-0">
          <p>
            {{ selectedTeacher.firstName }}, {{ selectedTeacher.lastName }},
            {{ currentSelectedLesson.name }}
          </p>
        </v-card-text>
        <v-card-actions class="pb-0">
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDelete"
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-ls
              bg-gradient-light
              py-3
              px-6
            "
            >Үгүй</v-btn
          >

          <v-btn
            @click="_deleteItemConfirm"
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-danger
              bg-gradient-danger
              py-3
              px-6
            "
            >Тийм</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { sync } from "vuex-pathify";
const fb = require("@/firebaseConfig.js");
export default {
  name: "Lessons",
  computed: {
    ...sync("*"),
    zzschool() {
      if (this.userData.ppschool) return this.userData.ppschool;
      else return "";
    },
    filteredLessons() {
      var list = [];
      var counter = 0;
      if (this.lessons) {
        for (var ll of this.lessons) {
          counter++;
          ll.name3 = counter + "." + ll.name2  
          list.push(ll);
        }
      }
      return list;
    },
    // filterLessonCategories() {
    //   if (this.lessonCategories)
    //     return this.lessonCategories.filter(
    //       (lesson) => lesson.lessonType == this.mustorselection
    //     );
    //   else return [];
    // },

    filterLessonCategories() {
      var list = [];
      var counter = 0;
      if (this.lessonCategories) {
        for (var ll of this.lessonCategories) {
          if (ll.lessonType == this.mustorselection) {
            counter++;
            ll.name3 = counter + ". " + ll.name2;
            list.push(ll);
          }
        }
      }
      return list;
    },
  },
  data() {
    return {
      currentSelectedLesson: null,
      filterLessonCategory: null,
      mustLessonSelected: true,
      nonMustLessonSelected: false,
      eyeshLessonSelected: false,

      selectedYear: null,
      dialogDelete: false,
      editedIndex: -1,
      selectedLessonCategory: null,
      path2: null,
      lessons: null,

      editedItem: {
        description: null,
      },
      defaultItem: {
        description: null,
      },
      addNewItem: false,
      videoId: null,
      lessonTypes: [
        { value: 1, name: "Заавал" },
        { value: 2, name: "Сонгон" },
        { value: 4, name: "Бага анги" },
      ],
      mustorselection: fb.EYESH_APP ? 3 : 1,
      lessonCategories: null,
      teachers: null,
      selectedTeacher: null,
    };
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    // query: {
    //   type: Object,
    //   required: true,
    // },
    headerNames: {
      type: Array,
      required: true,
    },
    addButtonText: {
      type: String,
      required: true,
    },
  },

  watch: {
    filterLessonCategory(val) {
      var query = fb.db
        .collection(this.zzschool + "/lessons")
        .where("deleted", "==", false)
        .where("categoryRef", "==", val.ref);

      if (this.userData.school.currentYear)
        query = query.where("year", "==", this.userData.school.currentYear);
      // if (this.userData.role == "teacher") {
      //   query = query.where("teacherRef", "==", this.userData.ref);
      // }
      query = query.orderBy("createdAt", "desc");
      query.onSnapshot((docs) => {
        this.lessons = [];
        docs.forEach((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          lesson.ref = doc.ref;
          this.lessons.push(lesson);
        });
      });
    },
    selectedLessonCategory(val) {
      console.log(val);
      if (this.editedItem && this.editedIndex == -1 && val) {
        this.editedItem.name = val.name;
      }
    },
  },
  created() {
    if (fb.EYESH_APP) {
      this.lessonTypes.push({ value: 3, name: "ЭЕШ" });
    }
    this.selectedYear = this.userData.school
      ? this.userData.school.currentYear
      : null;
  },
  mounted() {
    fb.db
      .collection("categories")
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        this.lessonCategories = [];
        querySnapshot.forEach((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          lesson.ref = doc.ref;
          lesson.name2 = lesson.name + " - " + lesson.lessonTypeName;
          lesson.my = false;
          this.lessonCategories.push(lesson);
        });
        if (this.userData.school) {
          this.userData.school.ref
            .collection("categories")
            .orderBy("name", "asc")
            .onSnapshot((querySnapshot) => {
              //this.lessonCategories = [];
              querySnapshot.forEach((doc) => {
                let lesson = doc.data();
                lesson.id = doc.id;
                lesson.ref = doc.ref;
                lesson.name2 = lesson.name + " - " + lesson.lessonTypeName + ' /сургуулийн/';
                lesson.my = true;
                this.lessonCategories.push(lesson);
              });
            });
        }
      });

    if (this.zzschool != null) {
      fb.db
        .collection(this.zzschool + "/teachers")
        .where("role", "==", "teacher")
        .orderBy("firstName", "asc")
        .get()
        .then((docs) => {
          this.teachers = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let x = doc.data();
            x.id = doc.id;
            x.ref = doc.ref;
            x.name2 = null;
            if (x.firstName) x.name2 = x.firstName;
            if (x.lastName) x.name2 = x.name2 + ", " + x.lastName;
            x.name2 = counter + ". " + x.name2;

            this.teachers.push(x);
          });
        });
    }

    var query = fb.db
      .collection(this.zzschool + "/lessons")
      .where("deleted", "==", false)

    if (this.userData.school && this.userData.school.currentYear)
      query = query.where("year", "==", this.userData.school.currentYear);
    if (this.userData.role == "teacher") {
      query = query.where("teacherRef", "==", this.userData.ref);
    }
    query = query.orderBy("createdAt", "desc");
    query.onSnapshot((docs) => {
      this.lessons = [];
      docs.forEach((doc) => {
        let lesson = doc.data();
        lesson.id = doc.id;
        lesson.ref = doc.ref;
        this.lessons.push(lesson);
      });
    });
  },
  methods: {
    _getJoinedName(item) {
      var llname = "";
      if (item.teacherLastName2) {
        llname = item.teacherLastName2 + ". " + item.teacherFirstName;
      } else if (item.teacherLastName && item.teacherLastName.length > 0) {
        llname = item.teacherLastName[0];
        llname = llname + ". " + item.teacherFirstName;
      } else llname = item.teacherFirstName;
      return llname;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.currentSelectedLesson = null;
        this.editedIndex = -1;
      });
    },
    async _deleteItem(item) {
      this.currentSelectedLesson = item;
      var xx = await item.teacherRef.get();
      this.selectedTeacher = xx.data();
      this.selectedTeacher.ref = xx.ref;
      this.selectedTeacher.id = xx.id;
      this.dialogDelete = true;
    },
    _deleteItemConfirm() {
      this.currentSelectedLesson.ref.update({ deleted: true }).then(() => {
        this.dialogDelete = false;
        if (
          this.currentSelectedLesson.teacherRef &&
          this.selectedTeacher[
            "numberOfLessons-" + this.userData.school.currentYear
          ] > 0
        ) {
          var x = {};
          x["numberOfLessons-" + this.userData.school.currentYear] =
            fb.firestore.FieldValue.increment(-1);

          this.currentSelectedLesson.teacherRef.update(x);
        }
      });
    },
    _editItem(item, index) {
      this.addNewItem = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      this.selectedTeacher = { id: item.teacherRef.id, ref: item.teacherRef };
      this.selectedLessonCategory = this.editedItem.categoryRef;
    },

    _getClassGroups(lesson) {
      var x = null;
      var y = null;
      if (lesson != null && lesson.classGroups != undefined) {
        lesson.classGroups.forEach((item) => {
          if (x != null) {
            x = x + ", " + item.departmentName + item.classGroupName;
            y = x.toUpperCase();
          } else {
            x = item.departmentName + item.classGroupName;
            y = x.toUpperCase();
          }
        });
      }
      return y;
    },
    _detailLesson(item) {
      this.$router.push({
        name: "PageLesson",
        params: {
          path: item.ref.path,
        },
      });
    },
    _addNewItem() {
      this.addNewItem = true;
      if (this.selectedLessonCategory)
        this.editedItem.name = this.selectedLessonCategory.name;
    },
    _close() {
      this.addNewItem = false;
      this.editedItem = {};
      this.selectedLessonCategory = null;
    },

    async _save() {
      this.editedItem.createdAt = new Date();
      if (this.mustorselection == 1) {
        this.editedItem.lessonType = this.mustorselection;
        this.editedItem.lessonTypeName = "Заавал";
        this.editedItem.isGroupBased = false;
      } else if (this.mustorselection == 2) {
        this.editedItem.lessonType = this.mustorselection;
        this.editedItem.lessonTypeName = "Сонгон";
        this.editedItem.isGroupBased = true;
      } else if (this.mustorselection == 3) {
        this.editedItem.lessonType = this.mustorselection;
        this.editedItem.lessonTypeName = "ЭЕШ";
        this.editedItem.isGroupBased = true;
      }

      if (
        (this.userData.role == "admin" ||
          this.userData.role == "superadmin" ||
          this.userData.role == "schooladmin") &&
        this.selectedTeacher
      ) {
        this.editedItem.teacherRef = this.selectedTeacher.ref;
        if (this.selectedTeacher.firstName)
          this.editedItem.teacherFirstName = this.selectedTeacher.firstName;
        if (this.selectedTeacher.lastName) {
          this.editedItem.teacherLastName = this.selectedTeacher.lastName;
          if (this.selectedTeacher.lastName2)
            this.editedItem.teacherLastName2 = this.selectedTeacher.lastName2;
        }
      } else {
        this.editedItem.teacherRef = this.userData.ref;
        if (this.userData.firstName)
          this.editedItem.teacherFirstName = this.userData.firstName;
        if (this.userData.lastName)
          this.editedItem.teacherLastName = this.userData.lastName;
      }

      this.editedItem.year = this.selectedYear;
      this.editedItem.deleted = false;
      console.log(this.editedItem);
      if (
        !(
          this.editedItem.classGroupRefs &&
          this.editedItem.classGroupRefs.length > 0
        )
      ) {
        this.editedItem.classGroupRefs = [];
      }
      if (this.selectedLessonCategory != null) {
        if (this.selectedLessonCategory.ref)
          this.editedItem.categoryRef = this.selectedLessonCategory.ref;
        else this.editedItem.categoryRef = this.selectedLessonCategory;

        var xx = await this.editedItem.categoryRef.get();
        if (xx.exists) this.editedItem.categoryName = xx.data().name;

        if (this.editedItem.ref) {
          this.editedItem.ref.set(this.editedItem, { merge: true }).then(() => {
            this._close();
          });
        } else {
          fb.db
            .collection(this.zzschool + "/lessons")
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log(this.editedItem.teacherRef.path);
              var x = {};
              if (this.userData.school.currentYear) {
                x["numberOfLessons-" + this.userData.school.currentYear] =
                  fb.firestore.FieldValue.increment(1);
              } else {
                x["numberOfLessons‰"] = fb.firestore.FieldValue.increment(1);
              }

              this.editedItem.teacherRef.update(x);
              this._close();
            });
        }
      }
    },
  },
};
</script>
